import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import {
  IComponentStateHistory,
  IValueChangedEvent,
  IWizardContentComponent
} from '../../../wizard.content';
import { DatasourceWizardService } from '../../../services/datasource/datasource.wizard.service';

@Component({
  selector: 'datasource-create-results-html',
  templateUrl: './datasource.create.results.page.html',
  providers: [],
  styleUrls: ['../datasource.style.scss', '../../../wizard.button.style.scss']
})
export class DatasourceCreateResultsComponent implements IWizardContentComponent, OnInit {
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('currentForm', { static: true }) form: NgForm;

  failureMsg: string;
  successFlag: string;
  successMsg: string;
  datasourceType: string;
  showActiveTestCreateResult = false;

  constructor(private wizardService: DatasourceWizardService) {}

  ngOnInit() {
    this.step.form = this.form;
    this.generateTextByMode(this.wizardService.editMode);
    this.showActiveTestCreateResult =
      this.datasourceType === 'GigaTestAgent' && !this.wizardService.editMode;
  }

  generateTextByMode(editMode: boolean): void {
    this.datasourceType = this.step.parent.output.datasourceType.id;
    const label =
      this.datasourceType === 'GigaTestAgent' && this.wizardService.editMode
        ? this.step.parent.output.datasourceType.label
        : this.step.parent.output.datasourceType.name;
    const name =
      this.datasourceType === 'GigaTestAgent' && !this.wizardService.editMode
        ? this.step.parent.output.alias
        : this.step.parent.output.name;
    if (!editMode) {
      this.failureMsg = 'There was a problem creating ' + label + ' ' + name + '.';
      this.successMsg = label + ' has been created';
      this.successFlag = '';
    } else {
      this.failureMsg = 'There was a problem updating ' + label + ' ' + name + '.';
      this.successMsg = `${label} agent has been updated`;
      this.successFlag = '';
    }
  }

  isLoading(): boolean {
    return this.wizardCtrl.getWizardService().isLoading;
  }

  requestFailed(): boolean {
    return this.wizardCtrl.getWizardService().requestFailed;
  }
}
